import React from 'react';
import { Provider } from 'react-redux';
import './index.css';
import '@fortawesome/fontawesome-pro/css/all.css';
import Router from './router';
import store from './store';

function App() {
  return (
    <Provider store={store}>
      <Router />
    </Provider>
  );
}

export default App;
